import React from "react";
import { Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RouteIcon from "@mui/icons-material/Route";
import { Button } from "@mui/material";

import Box from "@mui/material/Box";

export function Row(props) {
  const {
    row,
    setSelectedRoute,
    setShowModalAddRoute,
    setPreviewRouteSelected,
    isRoutesAssigned,
  } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row?.nameRoute ?? ""}
        </TableCell>
        <TableCell align="center">{row?.description ?? ""}</TableCell>
        <TableCell align="center">{row?.distance}</TableCell>
        <TableCell align="center">{row?.difficulty ?? ""}</TableCell>
        <TableCell align="center">{row?.terrainType ?? ""}</TableCell>
        <TableCell align="center">{row?.membershipType ?? ""}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          align="center"
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: "flex",
                  gap: 4,
                  padding: 2,
                }}
              >
                {!isRoutesAssigned && (
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#e7ef7d" }}
                    onClick={() => {
                      setSelectedRoute(row);
                      setShowModalAddRoute(true);
                    }}
                    startIcon={<RouteIcon />}
                  >
                    Asignar ruta
                  </Button>
                )}
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "#e7ef7d" }}
                  onClick={() => {
                    setPreviewRouteSelected(row);
                    const previewMap =
                      document.getElementById("previewMapProvider");
                    if (previewMap) {
                      previewMap.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                  startIcon={<VisibilityIcon />}
                >
                  Ver ruta
                </Button>
              </Box>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
